var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("div", { staticClass: "section-label" }, [
        _vm._v("\n    " + _vm._s(_vm.tc("booking.taxesAndFees")) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "see-details",
        {
          scopedSlots: _vm._u([
            {
              key: "details",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "overview-items-wrapper" },
                    _vm._l(_vm.itemsToJoin, function (key, i) {
                      return _c(
                        "div",
                        {
                          key: key,
                          staticClass: "overview-item",
                          class: [
                            { "small-margin": i < _vm.itemsToJoin.length - 1 },
                          ],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "item-label section-label" },
                            [
                              _vm._v(
                                "\n            " + _vm._s(key) + "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-value" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getDisplayPrice({
                                    price: _vm.mergedTaxesAndFees[key],
                                  })
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "overview-item" }, [
            _c("div", { staticClass: "item-label bold-item" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("booking.total")) +
                  " " +
                  _vm._s(_vm.tc("booking.taxesAndFees")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-value bold-item" }, [
              _vm._v("\n        " + _vm._s(_vm.totalTaxes) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _vm.addOnsInCart.length > 0 ? _c("add-ons-taxes-overview") : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }